import { render, staticRenderFns } from "./dispatch_bookings_driver_bid_manager_board_tbn.vue?vue&type=template&id=3569a33a&scoped=true&"
import script from "./dispatch_bookings_driver_bid_manager_board_tbn.vue?vue&type=script&lang=js&"
export * from "./dispatch_bookings_driver_bid_manager_board_tbn.vue?vue&type=script&lang=js&"
import style0 from "./dispatch_bookings_driver_bid_manager_board_tbn.vue?vue&type=style&index=0&id=3569a33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3569a33a",
  null
  
)

export default component.exports